import script from "./TableButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableButton.vue?vue&type=script&lang=ts&setup=true"

import "./TableButton.vue?vue&type=style&index=0&id=29d853a3&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d853a3"]])

export default __exports__